import React from "react";
import {
  Typography,
  Tabel,
  DropDown,
  DropDownMenu,
  FilterWraper,
} from "../core";
import { Link } from "react-router-dom";
import { theme } from "../styles";
import { Menu } from "antd";
import { useSelector } from "react-redux";
import { getCompanyClothReturns } from "../helper/utils/api/dispatch";
import { getCompanyId } from "../helper/utils/companyId";
const { textColor } = theme;
const CHANGE_DATE_FORMAT = require("../helper/utils/datFormat");
const columns = [
  {
    title: "Date",
    dataIndex: "date_cloth_return",
    key: "date_cloth_return",
    render: (text, record, index) => {
      return (
        <span>
          {/* {record.invoice_date}
          <br /> */}
          {CHANGE_DATE_FORMAT.changeDateFormat(record.date_cloth_return)}
        </span>
      );
    },
    width: 150,
  },
  {
    title: "Contract#",
    dataIndex: "contract_no",
    key: "contract_no",

    width: 150,
  },

  {
    title: "Net Pass",
    dataIndex: "net_pass",
    key: "net_pass",
    width: 150,
  },
  {
    title: "P Patch #",
    dataIndex: "p_patch_parchi_no",
    key: "p_patch_parchi_no",

    width: 150,
  },
  {
    title: "G/L/R Recieved",
    dataIndex: "glr_received",
    key: "glr_received",

    width: 150,
  },
  {
    title: "Action",
    dataIndex: "action",
    width: 150,
    render: (text, record, index) => (
      <DropDown
        overlay={<MenuCompo index={index} record={record} />}
        record={record}
      />
    ),
  },
];

const typoProps = {
  as: "h3",
  weight: "bold",
  letterSpacing: "0.2px",
  color: textColor.primary,
  text: "Return List",
};
const DispatchHistory = ({ theme, ...props }) => {
  const companyClothReturn = useSelector(
    (state) => state.clothReturn.clothReturnHis
  );
  const [records, setRecords] = React.useState([]);
  const [clothReturn, setclothReturn] = React.useState([]);

  React.useEffect(() => {
    const load = async () => {
      const companyId = getCompanyId();
      if (!companyId) return;
      try {
        const { data } = await getCompanyClothReturns(companyId);
        const list = data?.result || data || [];
        setRecords(Array.isArray(list) ? list : []);
      } catch (error) {
        console.log("cloth return error", error);
        setRecords(companyClothReturn || []);
      }
    };
    load();
  }, [companyClothReturn]);

  React.useEffect(() => {
    setclothReturn(records);
  }, [records]);

  const dateRange = (date, dateString) => {
    let min = dateString[0];
    let max = dateString[1];

    const filteredArray = records.filter((record) => {
      return record.date_cloth_return >= min && record.date_cloth_return <= max;
    });

    setclothReturn(min && max ? filteredArray : records);
  };

  const changeInput = (e) => {
    let search_input = e.target.value;
    const filteredArrayByBuyer = records.filter((record) => {
      return (
        record.p_patch_parchi_no.indexOf(search_input) > -1 ||
        record.contract_no.indexOf(search_input) > -1
      );
    });
    setclothReturn(filteredArrayByBuyer);
  };

  return (
    <>
      <Typography {...typoProps} />
      <FilterWraper
        rangeFilter={dateRange}
        inpputChange={changeInput}
        dropDown={false}
        range={true}
      ></FilterWraper>
      <Tabel
        // loading={!dispatchHistory[0] ? true : false}
        padding="0px 10px"
        // pagination={false}
        columns={columns}
        data={clothReturn}
        rowKey={({ dispatch_id }) => dispatch_id}
      />
    </>
  );
};

const MenuCompo = (props) => {
  return (
    <div>
      <DropDownMenu>
        <Menu.Item className="menu--item" key="edit">
          <Link to="">Edit</Link>
        </Menu.Item>
        <Menu.Item className="menu--item" key="edit">
          <Link to="">Delete</Link>
        </Menu.Item>
      </DropDownMenu>
    </div>
  );
};
export default DispatchHistory;
